// extracted by mini-css-extract-plugin
export var container = "_5b-0";
export var icon = "_5b-1";
export var text = "_5b-2";